<script lang="ts">
	import Icon from "#lib/components/Icon.svelte";
	import PhoneNumberInput from "#lib/components/PhoneNumberInput.svelte";
	import { stringValueFromDataTypeValue, type DataTypeInputProps } from "#lib/components/flow/editor/data-types/inputs/dataTypeInput.js";
	import { getCountryCodeFromNumber, getCountryCodeIconFromCountryCode } from "#lib/phonenumber.js";

	let { value = $bindable(), defaultValue, disabled, invalid, required, oninput, onchange, onblur }: DataTypeInputProps = $props();

	const countryCode = $derived(getCountryCodeFromNumber(stringValueFromDataTypeValue(value) ?? ""));
	const countryCodeIcon = $derived(getCountryCodeIconFromCountryCode(countryCode));
</script>

<div class="relative w-full">
	{#if countryCodeIcon}
		<Icon iconSet="cif" name={countryCodeIcon} data-action-name="phone-country-flag" data-country-code={countryCodeIcon} class="pointer-events-none absolute top-1/2 left-3 z-10 h-3 w-5 -translate-y-1/2" />
	{/if}
	<PhoneNumberInput class={countryCodeIcon ? "ps-10" : undefined} bind:value={() => stringValueFromDataTypeValue(value) ?? "", v => (value = v)} placeholder={defaultValue as unknown as string} {disabled} {required} color={invalid ? "red" : undefined} on:input={e => oninput?.(e)} on:change={e => onchange?.(e)} on:blur={e => onblur?.(e)} />
</div>
